import { render } from "./ZoomBtn.vue?vue&type=template&id=0cbfe70a&scoped=true"
import script from "./ZoomBtn.vue?vue&type=script&lang=js"
export * from "./ZoomBtn.vue?vue&type=script&lang=js"

import "./ZoomBtn.vue?vue&type=style&index=0&id=0cbfe70a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cbfe70a"]])

export default __exports__